<template>
  <div class="newsInfo-page">
    <Header 
      @onChangeSetting="onChangeSetting" @onChangLogin="onChangLogin" :setShow="['timeZone', 'order', 'oddsType', 'oddsForm']" 
      :tsz="svrTimestamp" :isLogin="loginShow" :myLeague="myLeague" @onLeagueFollowChange="onLeagueFollowChange" ref="Header"
      :navTab="5" :pageType="'poster'"
    />
    <div class="pageContent flex ai-s">
      <div class="news" v-if="Object.keys(newsInfo).length != 0">
        <div>
          <!-- 新闻类别 -->
          <div class="newsType" :class="isCeiling?'ceiling_on':''" v-if="newsCategoryList.length > 0">
            <ul class="flex" @mousedown="mousedown" @mouseup="mouseup" @mousemove="mousemove" ref="newsType">
              <li @click="changeType(0)" >{{ langConfig.news[langConfig.curLang]['ALL'] }}</li>
              <li @click="changeType(item.id)" v-for="(item,index) in newsCategoryList" :key="index" :class="newsInfo.category.name == item.name ? 'active' : ''">{{item.name}}</li>
            </ul>
          </div>
          <!-- 面包屑 -->
          <div class="crumb flex flex-align-center" v-if="newsInfo.hasOwnProperty('category')">
            <router-link :to="{path:'/news/0'}">{{ langConfig.news[langConfig.curLang]['NEWS'] }}</router-link>
            <span> > </span>
            <router-link :to="{path:'/news/' + newsInfo.category.id}">{{ newsInfo.category.name }}</router-link>
            <span> > </span>
            <!-- <div class="main-text">{{ langConfig.news[langConfig.curLang]['MAIN_TEXT'] }}</div> -->
            <div class="main-text">{{ newsInfo.title }}</div>
          </div>
          <!-- 内容 -->
          <div class="infoBox" v-if="Object.keys(this.newsInfo).length != 0">
            <div class="account flex flex-align-center" v-if="newsInfo.hasOwnProperty('author')">
              <div class="account-img" v-if="newsInfo.author.avatar"><img :src="newsInfo.author.avatar"></div>
              <div class="account-name">{{ newsInfo.author.name }}</div>
            </div>
            <h1 class="info-title">{{ newsInfo.title }}</h1>
            <div class="info-source">
              {{ langConfig.news[langConfig.curLang]['POSTED'] }} {{ weekArr[new Date(getMatchTime(newsInfo.createTime,'YYYY/MM/dd')).getDay()] }}, 
              <!-- {{ datetimeStr(newsInfo.createTime * 1000,0) }}  -->
              {{ getMatchTime(newsInfo.createTime,'dd/MM/YYYY') }}
              <span v-if="newsInfo.source && newsInfo.source != 'undefined'">
                {{ langConfig.news[langConfig.curLang]['BY'] }} 
                <span :class="isEffectiveWeb == true ? 'isEffectiveWeb' : ''" @click="toSourceWeb(newsInfo.source)">{{ newsInfo.source.indexOf('7M Sport') != -1 ? 'luckscore' : newsInfo.source}}</span>
              </span> 
            </div>
            <div class="info-content" v-html="newsInfo.content"></div>
          </div>
        </div>
      </div>
      <div class="page-right">
        <div class="title">Prediction</div>
        <div class="flex">
          <ul class="tab flex">
            <li :class="mType == 1 ? 'active' : ''" @click="changeMType(1)">1x2</li>
            <li :class="mType == 2 ? 'active' : ''" @click="changeMType(2)">AH</li>
            <li :class="mType == 3 ? 'active' : ''" @click="changeMType(3)">O/U</li>
            <li :class="mType == 4 ? 'active' : ''" @click="changeMType(4)">Scores</li>
            <li :class="mType == 5 ? 'active' : ''" @click="changeMType(5)">Goals</li>
          </ul>
        </div>
        <ul class="list">
          <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.homeTeam.fullName }}</div>
            </div>
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.awayTeam.fullName }}</div>
            </div>
            <div class="league flex flex-align-center">
              <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime, 'dd MM YYYY,HH:mm')}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

import { getNewsCategory, getNewsDetail, getNewsInfoHits, getPredictionRelateMatch } from '@/api/api';

export default {
  name: "newsInfo-c",
  components: {
    Header,
    Footer,
  },

  data() {
    return {
      loginShow: false
      // ,isloadingShow: true
      ,newsCategoryList: []
      // ,newsId: 1367
      ,newsId: this.$route.params.id
      ,newsInfo: {}
      ,weekArr: this.langConfig.txtLang[this.langConfig.curLang]['DAY_WEEK']
      ,ListAd: []
      ,isEffectiveWeb: false
      ,isDown: false // 是否按下鼠标
      ,startX: 0 // 鼠标起始位置
      ,typeScrollLeft: 0 // 滚动条位置
      ,isCeiling: false  //是否吸顶

      ,svrTimestamp: 0 // 系统时间
      ,myLeague: {}
      ,baseParam: { 
        userToken: '',
        langNumber: 3,//语言标识(公共参。1=简 2=繁 3=英 4=韩 5=泰 6=越 7=日本).
        platform: 4,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
        appVersion:'eg.3.25.0',//版本号(公共参。eg.3.25.0).
        portType: 1,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
        sportType: 1,//1足球2篮球(非公共参)
      }
      ,mType: 1
      ,relateMatch: [] //关联比赛
      ,relateLeague: [] //关联联赛
      ,setting: {
        oddsFormRadio: 1,
        tsz: '+08:00'
      }
      ,timeZone: '+08:00'
      ,changeFlag: null
      
    }
  },

  computed: {
      ...mapState('newsInfo', ['SEO']),
  },

  methods:{
    // 设置回调参数操作
    onChangeSetting(e){
      console.log('设置回调参数操作', e)
      let _setting = e;
      
      let _oddsForm = this.common.jsonParse(this.setting.oddsFormRadio)*1;
      let _tsz = JSON.parse(JSON.stringify(this.timeZone));


      if(_oddsForm != _setting.oddsFormRadio*1){ //赔率格式
        this.setting.oddsFormRadio = _setting.oddsFormRadio*1;
        return;
      }

      if(_tsz != _setting.tsz){ //时区
        this.setting['tsz'] = this.timeZone = _setting.tsz;
        this.getNewsDetailData()
        this.predictionRelateMatchList()
      }
    },
    // 登录弹窗回调
    onChangLogin(val){
      let _val = val;
      this.loginShow = _val.loginShow;
    },
    // 关注赛事变化回调
    onLeagueFollowChange(val){
      if(val){
        this.myLeague = val;
      }
    },
    // 获取关注联赛
    getFavLeagues(){
      let _myLeague = this.common.getStorage('leagueListFollow');
      if(_myLeague != null){
        this.myLeague = JSON.parse(_myLeague);
      }
    },

    changeMType(type){
      this.mType = type
    },

    async predictionRelateMatchList(){
      var _userInfo = '';
      if(typeof window!='undefined'){
        _userInfo=this.common.getCookie('userInfo')||'{}';//
        _userInfo = JSON.parse(_userInfo)
      }
      let obj = {
        userToken:_userInfo.token,
        // userToken:'470ae4ec3ecf51263034301c7e1f4b5a7750aa88',
        leagueId: 0,   //完场
        mType: this.mType,
        matchId: 0,
      }
      let param = Object.assign( this.baseParam,obj);
      await getPredictionRelateMatch(param).then((res) => {
        this.relateMatch = res.data.relateMatch
        this.relateLeague = res.data.relateLeague
      })
    },
    
    // 关联比赛
    changeMatch(item){
      let tab = this.common.getTabChildName(this.mType)
      let _homeName = this.common.formalTitle(item.homeTeam.fullName)
      let _awayName = this.common.formalTitle(item.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },

    // 点击量
    async getNewsInfoHitsData(){
      await getNewsInfoHits({newsId: this.newsId}).then((res) => {
      }).catch((res) => {
      })
    },
    
    getGameTime(startTime,_dateForm){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },
    
    // 获取更新时间
    getMatchTime(val,dateForm){
      let _val = val;
      let _tsz = this.setting.tsz;
      var setting=this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let _time = this.common.getDateByArray(_tsz, _val);
      
      return this.common.dateStr(_time, dateForm);
    },

    //数据读取-新闻-分类
    async getNewsCategoryData(){
      let param = {
        userToken: '',
        langNumber: 3,//语言标识(公共参。1=简 2=繁 3=英 4=韩 5=泰 6=越 7=日本).
        platform: 4,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
        sportType: 1,//1足球2篮球(非公共参)
      }
      if(typeof window!='undefined'){
        let _userInfo = this.common.getCookie('userInfo');
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }
      }

      await getNewsCategory(param).then((res) => {
        this.newsCategoryList = res.data.categoryList
        // this.isloadingShow = false
      }).catch((res) => {
        console.error(res)
      })
    },

    //数据读取-新闻-详细
    async getNewsDetailData(){
      let param = {
        newsId: this.newsId,
        userToken: '',
        langNumber: 3,//语言标识(公共参。1=简 2=繁 3=英 4=韩 5=泰 6=越 7=日本).
        platform: 4,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
        sportType: 1,//1足球2篮球(非公共参)
      }

      if(typeof window!='undefined'){
        let _userInfo = this.common.getCookie('userInfo');
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }
      }

      await getNewsDetail(param).then((res) => {
        this.newsInfo = res.data
        console.log(res.data)
        document.title = this.newsInfo.title + this.SEO.title;

        let url = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/[\]@!\$&'\*\+,;=.]+$/;
        if (!url.test(res.data.source)) {
          this.isEffectiveWeb = false
        } else {
          this.isEffectiveWeb = true
        }
        // this.isloadingShow = false

        
      }).catch((res) => {
        console.error(res)
      })
    },
    // 跳转来源网址 
    toSourceWeb(web){
      if(this.isEffectiveWeb){
        if(web.indexOf('http') != -1){
          window.open(web)
        }else{
          window.open('//' + web)
        }
        
      }
    },
    // 选择类别
    changeType(id){
      let that = this;
      if(this.changeFlag != null){
        clearTimeout(this.changeFlag);
      }
      this.changeFlag = setTimeout(function() {
        that.$router.push(`/news/${id}`);
      }, 500)
    },
    //时间转换
    datetimeStr(str, type){
      var date = new Date(parseInt(str));
        var YYYY = date.getFullYear();
        var year = date.getYear()
        var year = year < 2000 ? year + 1900 : year
        var YY = year.toString().substr(2, 2);
        var MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        var dd = date.getDate();
        dd = dd < 10 ? "0" + dd : dd;
        var Bd = date.getDate();
        Bd = Bd *1;
        var HH = date.getHours();
        HH = HH < 10 ? "0" + HH : HH;
        var HD = date.getHours();
        HD = HD*1;
        var mm = date.getMinutes();
        mm = mm < 10 ? "0" + mm : mm;
        var ss = date.getSeconds();
        ss = ss < 10 ? "0" + ss : ss;

        var formal = [
        "dd/MM/YYYY",
        ];

        if(this.langConfig.curLang == 'kr'){
          formal = ["YYYY-MM-dd"];
        }

        return formal[type]
        .replace("YYYY", YYYY)
        .replace("YY", YY)
        .replace("MM", MM)
        .replace("dd", dd)
        .replace("HH", HH)
        .replace("mm", mm)
        .replace("ss", ss)
        .replace("Bd", Bd)
        .replace("HD", HD);
    },

    /* 分类拖动-start */
    mousedown(event){
      this.isDown = true;
      this.startX = event.pageX - this.$refs.newsType.offsetLeft
      this.typeScrollLeft = this.$refs.newsType.scrollLeft
    },
    mouseup(event){
      this.isDown = false
    },
    mousemove(event){
      if (!this.isDown) return
      event.preventDefault();
      const x = event.pageX - this.$refs.newsType.offsetLeft;
      const walk = (x - this.startX) * 2; // 滑动距离
      this.$refs.newsType.scrollLeft = this.typeScrollLeft - walk;
    },
    /* 分类拖动-end */

    handleScroll() {
      if(typeof window!='undefined'){
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        let Header= (this.$refs.Header?this.$refs.Header.$el.clientHeight*1:null);
        if(!Header){
          return;
        }
        console.log(Header)
        let dif_H= scrollTop-Header;
        this.isCeiling=(dif_H>0?true:false);
      }
    },

    pageCount() {
      let _url ='https://count.7mdt.com/flowstats/count.js?type=2&lang=3&dataId=' + this.newsId;
      this.common.loadExternalScript('pageCount', _url);
    },
  },
  mounted(){
    // 监听body滚动事件
    if(typeof window!='undefined'){
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器
    if(typeof window!='undefined'){
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  created(){
    this.common.googleEvent('LS_PC_NewsDetails');

    if(typeof(window) != 'undefined'){
      this.handleScroll();
      // this.pageCount();
    }
    this.getNewsDetailData()
    this.getNewsCategoryData();
    this.getNewsInfoHitsData()

    this.predictionRelateMatchList()
  },
  watch:{
    mType(){
      this.predictionRelateMatchList()
    }
  }
}
</script>
<style lang="less">
@import '~@/style/news/info.less';
</style>


// WEBPACK FOOTER //
// ./src/views/news/info.vue